"use client";
import SvgArrowBackwardFilled from "./arrow_backward-filled.svg.js";
import SvgArrowBackwardOutlined from "./arrow_backward-outlined.svg.js";
import SvgArrowBackwardRound from "./arrow_backward-round.svg.js";
import SvgArrowBackwardSharp from "./arrow_backward-sharp.svg.js";
import SvgArrowDownwardFilled from "./arrow_downward-filled.svg.js";
import SvgArrowDownwardOutlined from "./arrow_downward-outlined.svg.js";
import SvgArrowDownwardRound from "./arrow_downward-round.svg.js";
import SvgArrowDownwardSharp from "./arrow_downward-sharp.svg.js";
import SvgArrowForwardFilled from "./arrow_forward-filled.svg.js";
import SvgArrowForwardOutlined from "./arrow_forward-outlined.svg.js";
import SvgArrowForwardRound from "./arrow_forward-round.svg.js";
import SvgArrowForwardSharp from "./arrow_forward-sharp.svg.js";
import SvgArrowUpwardFilled from "./arrow_upward-filled.svg.js";
import SvgArrowUpwardOutlined from "./arrow_upward-outlined.svg.js";
import SvgArrowUpwardRound from "./arrow_upward-round.svg.js";
import SvgArrowUpwardSharp from "./arrow_upward-sharp.svg.js";
import SvgCheckFilled from "./check-filled.svg.js";
import SvgCheckOutlined from "./check-outlined.svg.js";
import SvgCheckRound from "./check-round.svg.js";
import SvgCheckSharp from "./check-sharp.svg.js";
import SvgChevronLeftFilled from "./chevron_left-filled.svg.js";
import SvgChevronLeftOutlined from "./chevron_left-outlined.svg.js";
import SvgChevronLeftRound from "./chevron_left-round.svg.js";
import SvgChevronLeftSharp from "./chevron_left-sharp.svg.js";
import SvgChevronRightFilled from "./chevron_right-filled.svg.js";
import SvgChevronRightOutlined from "./chevron_right-outlined.svg.js";
import SvgChevronRightRound from "./chevron_right-round.svg.js";
import SvgChevronRightSharp from "./chevron_right-sharp.svg.js";
import SvgCloseFilled from "./close-filled.svg.js";
import SvgCloseOutlined from "./close-outlined.svg.js";
import SvgCloseRound from "./close-round.svg.js";
import SvgCloseSharp from "./close-sharp.svg.js";
import SvgExpandLessFilled from "./expand_less-filled.svg.js";
import SvgExpandLessOutlined from "./expand_less-outlined.svg.js";
import SvgExpandLessRound from "./expand_less-round.svg.js";
import SvgExpandLessSharp from "./expand_less-sharp.svg.js";
import SvgExpandMoreFilled from "./expand_more-filled.svg.js";
import SvgExpandMoreOutlined from "./expand_more-outlined.svg.js";
import SvgExpandMoreRound from "./expand_more-round.svg.js";
import SvgExpandMoreSharp from "./expand_more-sharp.svg.js";
import SvgExternalFilled from "./external-filled.svg.js";
import SvgExternalOutlined from "./external-outlined.svg.js";
import SvgExternalRound from "./external-round.svg.js";
import SvgExternalSharp from "./external-sharp.svg.js";
import SvgMenuFilled from "./menu-filled.svg.js";
import SvgMenuOutlined from "./menu-outlined.svg.js";
import SvgMenuRound from "./menu-round.svg.js";
import SvgMenuSharp from "./menu-sharp.svg.js";
import SvgMoreHorizontalFilled from "./more_horizontal-filled.svg.js";
import SvgMoreHorizontalOutlined from "./more_horizontal-outlined.svg.js";
import SvgMoreHorizontalRound from "./more_horizontal-round.svg.js";
import SvgMoreHorizontalSharp from "./more_horizontal-sharp.svg.js";
import SvgMoreVerticalFilled from "./more_vertical-filled.svg.js";
import SvgMoreVerticalOutlined from "./more_vertical-outlined.svg.js";
import SvgMoreVerticalRound from "./more_vertical-round.svg.js";
import SvgMoreVerticalSharp from "./more_vertical-sharp.svg.js";
import SvgOpenFilled from "./open-filled.svg.js";
import SvgOpenOutlined from "./open-outlined.svg.js";
import SvgOpenRound from "./open-round.svg.js";
import SvgOpenSharp from "./open-sharp.svg.js";
import SvgRefreshFilled from "./refresh-filled.svg.js";
import SvgRefreshOutlined from "./refresh-outlined.svg.js";
import SvgRefreshRound from "./refresh-round.svg.js";
import SvgRefreshSharp from "./refresh-sharp.svg.js";
import SvgSpinnerFilled from "./spinner-filled.svg.js";
import SvgSpinnerOutlined from "./spinner-outlined.svg.js";
import SvgSpinnerRound from "./spinner-round.svg.js";
import SvgSpinnerSharp from "./spinner-sharp.svg.js";
import SvgUnfoldLessFilled from "./unfold_less-filled.svg.js";
import SvgUnfoldLessOutlined from "./unfold_less-outlined.svg.js";
import SvgUnfoldLessRound from "./unfold_less-round.svg.js";
import SvgUnfoldLessSharp from "./unfold_less-sharp.svg.js";
import SvgUnfoldMoreFilled from "./unfold_more-filled.svg.js";
import SvgUnfoldMoreOutlined from "./unfold_more-outlined.svg.js";
import SvgUnfoldMoreRound from "./unfold_more-round.svg.js";
import SvgUnfoldMoreSharp from "./unfold_more-sharp.svg.js";
const arrow_backward = {
  filled: SvgArrowBackwardFilled,
  outlined: SvgArrowBackwardOutlined,
  round: SvgArrowBackwardRound,
  sharp: SvgArrowBackwardSharp
};
const arrow_downward = {
  filled: SvgArrowDownwardFilled,
  outlined: SvgArrowDownwardOutlined,
  round: SvgArrowDownwardRound,
  sharp: SvgArrowDownwardSharp
};
const arrow_forward = {
  filled: SvgArrowForwardFilled,
  outlined: SvgArrowForwardOutlined,
  round: SvgArrowForwardRound,
  sharp: SvgArrowForwardSharp
};
const arrow_upward = {
  filled: SvgArrowUpwardFilled,
  outlined: SvgArrowUpwardOutlined,
  round: SvgArrowUpwardRound,
  sharp: SvgArrowUpwardSharp
};
const check = {
  filled: SvgCheckFilled,
  outlined: SvgCheckOutlined,
  round: SvgCheckRound,
  sharp: SvgCheckSharp
};
const chevron_left = {
  filled: SvgChevronLeftFilled,
  outlined: SvgChevronLeftOutlined,
  round: SvgChevronLeftRound,
  sharp: SvgChevronLeftSharp
};
const chevron_right = {
  filled: SvgChevronRightFilled,
  outlined: SvgChevronRightOutlined,
  round: SvgChevronRightRound,
  sharp: SvgChevronRightSharp
};
const close = {
  filled: SvgCloseFilled,
  outlined: SvgCloseOutlined,
  round: SvgCloseRound,
  sharp: SvgCloseSharp
};
const expand_less = {
  filled: SvgExpandLessFilled,
  outlined: SvgExpandLessOutlined,
  round: SvgExpandLessRound,
  sharp: SvgExpandLessSharp
};
const expand_more = {
  filled: SvgExpandMoreFilled,
  outlined: SvgExpandMoreOutlined,
  round: SvgExpandMoreRound,
  sharp: SvgExpandMoreSharp
};
const external = {
  filled: SvgExternalFilled,
  outlined: SvgExternalOutlined,
  round: SvgExternalRound,
  sharp: SvgExternalSharp
};
const menu = {
  filled: SvgMenuFilled,
  outlined: SvgMenuOutlined,
  round: SvgMenuRound,
  sharp: SvgMenuSharp
};
const more_horizontal = {
  filled: SvgMoreHorizontalFilled,
  outlined: SvgMoreHorizontalOutlined,
  round: SvgMoreHorizontalRound,
  sharp: SvgMoreHorizontalSharp
};
const more_vertical = {
  filled: SvgMoreVerticalFilled,
  outlined: SvgMoreVerticalOutlined,
  round: SvgMoreVerticalRound,
  sharp: SvgMoreVerticalSharp
};
const open = {
  filled: SvgOpenFilled,
  outlined: SvgOpenOutlined,
  round: SvgOpenRound,
  sharp: SvgOpenSharp
};
const refresh = {
  filled: SvgRefreshFilled,
  outlined: SvgRefreshOutlined,
  round: SvgRefreshRound,
  sharp: SvgRefreshSharp
};
const spinner = {
  filled: SvgSpinnerFilled,
  outlined: SvgSpinnerOutlined,
  round: SvgSpinnerRound,
  sharp: SvgSpinnerSharp
};
const unfold_less = {
  filled: SvgUnfoldLessFilled,
  outlined: SvgUnfoldLessOutlined,
  round: SvgUnfoldLessRound,
  sharp: SvgUnfoldLessSharp
};
const unfold_more = {
  filled: SvgUnfoldMoreFilled,
  outlined: SvgUnfoldMoreOutlined,
  round: SvgUnfoldMoreRound,
  sharp: SvgUnfoldMoreSharp
};
export {
  arrow_backward,
  arrow_downward,
  arrow_forward,
  arrow_upward,
  check,
  chevron_left,
  chevron_right,
  close,
  expand_less,
  expand_more,
  external,
  menu,
  more_horizontal,
  more_vertical,
  open,
  refresh,
  spinner,
  unfold_less,
  unfold_more
};
